import { create } from "zustand";

interface AssignedClaimStore {
  isClaimAssigned: boolean;
  setIsClaimAssigned: (value: boolean) => void;
}

export const useAssignedClaimStore = create<AssignedClaimStore>((set) => ({
  isClaimAssigned: false,
  setIsClaimAssigned: (value) => set({ isClaimAssigned: value }),
}));
